import { ImportantDates } from "../../../common/assets/js/classes";
import { appLocale } from "../../../common/assets/js/constants";

export class myImptDates extends ImportantDates {
    dateTime(params) {
        const date = new Date(params).toLocaleString(appLocale, {
            timeZone: "America/New_York", // eastern timezone
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            timeZoneName: "short",
        });
        return date;
    }
}
